import { makeStyles } from '@material-ui/core/styles';
import { userTheme } from 'consts/config';

export default makeStyles(theme => ({
  DetailsCard: {
    padding: 10,
    '&__padding-left': {
      paddingLeft: 15,
    },
    '&__header': {
      width: 'calc(100% + 20px)',
      margin: -10,
      padding: 10,
      marginBottom: 20,
    },
    '&__margin-auto': {
      margin: 'auto',
    },
    '&__icon': {
      width: '75%',
      filter:
        theme.palette.type === userTheme.dark
          ? 'brightness(100%)'
          : 'brightness(0%)',
    },
    '&__span-title': {
      color: '#94A3B8',
      fontSize: '0.65rem',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
    },
    '&__span-value': {
      color: theme.typography.color.primary,
      fontSize: '0.8rem',
      fontFamily: "'JetBrains Mono', 'Consolas', monospace",
      fontWeight: 500,
      fontVariantNumeric: 'tabular-nums',
    },
    '&__button': {
      width: '70%',
      marginLeft: '20%',
      fontSize: '0.7rem',
      padding: 2,
      marginTop: 0,
      marginBottom: 3,
    },
    '&__switch': {
      '&__text': {
        color: theme.palette.primary.main,
        fontWeight: 500,
        fontSize: '0.7rem',
        marginLeft: 9,
      },
    },
    // '&__data': {
    //   '&__item': {
    //     alignItems: 'center',
    //     display: 'flex',
    //     flexGrow: 0,
    //     justifyContent: 'center',
    //     maxWidth: '250px',
    //     '&__icon': {
    //       filter:
    //         theme.palette.type === userTheme.dark
    //           ? 'brightness(100%)'
    //           : 'brightness(0%)',
    //       width: '40%',
    //     },
    //     '&__item-container': {
    //       alignItems: 'center',
    //       justifyContent: 'space-between',
    //       padding: '0 5px',
    //     },
    //   },
    // },
    '&__loader': {
      display: 'flex',
      height: '50px',
      justifyContent: 'center',
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(3),
      width: '100%',
    },
    '&__weather-container': {
      marginTop: 25,
    },
    '&__weather': {
      '&__title': {
        display: 'flex',
        fontWeight: 600,
        fontSize: '0.8rem',
        justifyContent: 'left',
      },
      '&__content': {
        alignItems: 'center',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        margin: '0 auto',
        marginBottom: theme.spacing(1),
        width: '100%',
        '&__desc': {
          alignItems: 'center',
          color: theme.palette.detailsCardDescColor,
          display: 'flex',
          fontWeight: 400,
          justifyContent: 'center',
          margin: '2px 0',
          textAlign: 'center',
          fontSize: '0.75rem',
          '&__button': {
            height: 20,
          },
          '&__container': {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            '&__svg': {
              height: '15px',
              width: '15px',
            },
          },
        },
        '&__conditions': {
          padding: '5px',
          textAlign: 'center',
        },
      },
      '&__expand-bar': {
        '&--color': {
          color: theme.palette.detailsCardDescColor,
        },
      },
    },
  },
}));
